import React__default from 'react';
import classnames from 'classnames';
import FocusTrap from 'focus-trap-react';
import { AnimatePresence, motion } from 'framer-motion';
import { useDrawer } from '../../context/DrawerContext.js';
import { lockScroll, unlockScroll } from '../../../Util/scroll-lock.js';
import { useStackedHandleOnEscape } from '../../../EscapeHandlerStack/hooks/use-stacked-handle-on-escape.js';

/** These variants are a mirror of the ones used in the Site Nav.
 * The Site Navigation overlay moves into the screen from the left,
 * the Drawer moves into the screen from the right. */ const transition = {
    ease: 'easeInOut',
    duration: 0.3
};
const verticalOverlayVariants = {
    open: {
        x: '0%',
        transition
    },
    closed: {
        x: '100%',
        transition
    }
};
const horizontalOverlayVariants = {
    open: {
        y: '0%',
        transition
    },
    closed: {
        y: '100%',
        transition
    }
};
const DrawerOverlay = ({ children , 'data-t': dataT , shouldMountContent =false ,  })=>{
    const { isOpen , close , direction  } = useDrawer();
    React__default.useEffect(()=>{
        if (isOpen) {
            lockScroll();
            return ()=>unlockScroll()
            ;
        }
    }, [
        isOpen
    ]);
    useStackedHandleOnEscape({
        isOpen,
        handler: close
    });
    const isActive = shouldMountContent || isOpen;
    return /*#__PURE__*/ React__default.createElement(AnimatePresence, null, isActive && /*#__PURE__*/ React__default.createElement(FocusTrap, {
        active: isOpen,
        focusTrapOptions: {
            clickOutsideDeactivates: true
        }
    }, /*#__PURE__*/ React__default.createElement(motion.div, {
        "data-t": dataT,
        role: "dialog",
        key: "drawer-overlay",
        className: classnames('drawer-overlay', `drawer-overlay--${direction}`),
        variants: direction === 'bottom' ? horizontalOverlayVariants : verticalOverlayVariants,
        animate: isOpen ? 'open' : 'closed',
        // reason: inert property lets us prevent tab focus on this element and its children
        // @ts-expect-error inert is not a property react supports yet
        inert: !isOpen ? '' : undefined,
        "aria-hidden": !isOpen,
        initial: "closed",
        exit: "closed"
    }, children)));
};

export { DrawerOverlay };
//# sourceMappingURL=DrawerOverlay.js.map
